import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { Icon } from "../Icon/Icon"

const Wrapper = styled.div`
  ${tw`flex flex-wrap w-full justify-center`}
  ${({ between }) => (between ? tw`justify-between` : tw`justify-center`)}
`
const Group = tw.div`flex mb-2`
const Label = tw.div`uppercase` // stylesmall
const StyeldIcon = tw(Icon)`mr-1`

const CartLabel = ({ contents, startFromLeft }) => {
  return (
    <Wrapper between={contents.length > 1 || startFromLeft}>
      {contents?.map((content, index) => (
        <Group key={index}>
          <StyeldIcon name={`tick`} size={15} />
          <Label className="body_small_highlight">{content}</Label>
        </Group>
      ))}
    </Wrapper>
  )
}

export default CartLabel
